import { LoanSummaryAccordion } from "./LoanSummaryAccordion";
import { LoanDetails } from "domain/yourBBLS";
import { SelectedTreatmentsDetails } from "domain/selectedTreatments";
import { AppSummaryHeading } from "./AppSummaryHeading";
import { SelectedTreatmentOptionSummary } from "./SelectedTreatmentOptionSummary";
import { Button } from "reactstrap";

type ApplicationSummaryProps = {
  loanDetails: LoanDetails;
  selectedTreatment: SelectedTreatmentsDetails;
  onSubmit: () => void;
  onEdit: () => void;
};

export const ApplicationSummary = ({
  loanDetails,
  selectedTreatment,
  onEdit,
  onSubmit,
}: ApplicationSummaryProps) => {
  return (
    <>
      <AppSummaryHeading
        treatmentOption={selectedTreatment.treatmentOptionType}
      />

      <LoanSummaryAccordion loanDetails={loanDetails} />

      <SelectedTreatmentOptionSummary
        selectedTreatments={selectedTreatment}
        onEdit={onEdit}
      />

      <div className="button-end">
        <Button color="primary" size="lg" onClick={onSubmit}>
          Submit Request
        </Button>
      </div>
    </>
  );
};
